// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconSushi = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M2.21 6.342C1.5 6.512 1 7.147 1 7.877v4.48c0 .818.79 1.404 1.573 1.167L3 13.397V15a4 4 0 004 4h10a4 4 0 004-4v-1.603q.214.062.427.127A1.22 1.22 0 0023 12.357v-4.48c0-.73-.5-1.365-1.21-1.535a42.1 42.1 0 00-19.58 0M6 7.64a40 40 0 00-3 .572v3.11a35 35 0 013-.669zm2-.251v2.971q1.496-.174 3-.218V7.2a40 40 0 00-3 .188m8 2.971a35 35 0 00-3-.218V7.2q1.502.038 3 .188zm2 .293q1.511.267 3 .669v-3.11q-1.492-.344-3-.572zM5 15v-2.11a32.5 32.5 0 0114 0V15a2 2 0 01-2 2H7a2 2 0 01-2-2"
    />
  );
export default SvgIconSushi;
